import { fromJS } from 'immutable';
import * as actionTypes from './actionTypes'

const initialState = fromJS({
  howItWorksData: {}
});

const howItWorks = (state = initialState, action) => {
    switch (action.type) {  
      case actionTypes.fetchHowItWorksDataSuccessType:   
        return  state.setIn(['howItWorksData'], action.payload[0])

      case  actionTypes.howItWorksDataFailedType:
        return state
        .setIn(['grantsCount', 'error'], action.payload);
        
      default:
        return state;
    }  
  };
  
  export default howItWorks;